import JournalBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import HeroBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import TrustBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import FaqsBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import PageHeaderBlock from "../../models/blocks/PageHeaderBlock";
import LinkBlock from "../../models/blocks/LinkBlock";
import PageFooterBlock from "../../models/blocks/PageFooterBlock";
import FooterLinksBlock from "../../models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "../../models/blocks/FooterBenefitsBlock";
import ComplianceBarBlock from "../../models/blocks/ComplianceBarBlock";
import AnnouncementBarBlock from "../../models/blocks/AnnouncementBarBlock";
export default {
  [AnnouncementBarBlock.NAME]: {
    default_announcement: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Free shipping Today!'
    }
  },
  [ComplianceBarBlock.NAME]: {
    default_compliance: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Copyright © {from}-{to} {domain_name}. All Rights Reserved.'
    }
  },
  [PageHeaderBlock.NAME]: {
    default_header: {
      [PageHeaderBlock.getLinksAttributeName()]: [{
        [LinkBlock.getNameAttributeName()]: 'Home'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Product'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Faq'
      }, {
        [LinkBlock.getNameAttributeName()]: 'About Us'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Contact'
      }]
    }
  },
  [PageFooterBlock.NAME]: {
    default_footer: {
      [PageFooterBlock.getSectionsAttributeName()]: [{}, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Informations',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Shipping and Return'
        }, {
          [LinkBlock.getNameAttributeName()]: 'FAQ'
        }, {
          [LinkBlock.getNameAttributeName()]: 'About us'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Contact'
        }]
      }, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Legal pages ',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Terms of Service'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Privacy Policy'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Refund Policy'
        }]
      }, {
        [FooterBenefitsBlock.getParagraphAttributeName()]: '<p style="padding: 0.1px"><strong>Secure payment</strong></p><p style="padding: 0.1px"><strong>Free Shipping, and Fast Delivery </strong><span><strong>( 5 to 8 days )</strong></span></p>'
      }]
    }
  },
  [HeroBlockForm.NAME]: {
    home: {
      text: '<p style="text-align: justify; padding: 0.1px" dir="ltr"><span style="font-size: 20pt; color: #FFFFFF">Amazing online shopping experience!</span></p><p style="text-align: justify; padding: 0.1px" dir="ltr"></p><ul dir="auto" style="padding-inline-start: 24px"><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 16pt; color: #FFFFFF">High quality products</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 16pt; color: #FFFFFF">Incredible discounts</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 16pt; color: #FFFFFF">Fast delivery times</span></p><p dir="auto" style="padding: 0.1px"></p></li></ul><p dir="auto" style="padding: 0.1px"><span style="font-size: 20pt; color: #FFFFFF">Don’t hesitate! You will love our products</span></p>',
      button_text: 'Shop Now'
    }
  },
  [ProductListBlockForm.NAME]: {
    discover_products: {
      title: 'Discover our products'
    }
  },
  [JournalBlockForm.NAME]: {
    amazing_delivery_experience: {
      title: 'Amazing delivery experience',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="ltr">You can place your order in our store with peace of mind, we partnered with the best couriers in {country_name} to provide you with fast delivery time of 5 to 8 days, and a secure payment method online, by card.</p>'
    },
    best_customer_service: {
      title: 'The Best customer service',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="auto">Our customer service team is always here to answer your questions and help you with your order, as well as in the after sale.We do our best to answer all of our customers in less than 24 hours. If you have any questions, please contact us from <a target="_blank" rel="noopener noreferrer nofollow" href="/contact"><strong>this page</strong></a></p>'
    },
    about_us: {
      title: 'ABOUT US',
      paragraph: '<p dir="auto" style="padding: 0.1px">:domain_title is an online store in :country_name specializing in innovative products and accessories that will make your daily life easier and a lot more fun.We try our best to provide quality support, and faster shipping times to our customers. We promise to process your orders in less than 24h, and to answer all your questions on time.We are happy to welcome you in our store, fell free to place orders any time :) Your satisfaction is our Goal.</p>'
    }
  },
  [TrustBlockForm.NAME]: {
    satisfaction_guarantee: {
      title: '100% Satisfaction Guarantee',
      paragraph: 'We offer free shipping on all products, and we give you 30 days of guarantee.',
      badges_list: [{
        text: 'Free Shipping'
      }, {
        text: 'Return Guarantee'
      }, {
        text: 'Secure Checkout'
      }, {
        text: 'Fast Customer Support'
      }]
    }
  },
  [FaqsBlockForm.NAME]: {
    home: {
      title: 'FAQ',
      other_questions_title: 'Do you have other questions?',
      other_questions_text: '<p style="color: #FFFFFF; text-align: center; padding: 0.1px" dir="ltr">Visit the contact page, and send us your message. We try our best to answer all our customers in less than 24h</p>',
      other_questions_button_text: 'Contact us',
      faqs_list: [{
        title: 'HOW CAN I FOLLOW MY ORDERS AND PAYMENTS?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr">We will send tracking number by email right after shipping your order.</p>'
      }, {
        title: 'WHAT IF I NEED TO RETURN THE PRODUCT?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr">Do not worry! Contact us as soon as possible in the first 7 days of receiving your order, and we will help you process the return and the refund or exchange.</p>'
      }, {
        title: 'HOW LONG DOES IT TAKE TO GET MY ORDER?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr">Your order will be delivered within 5-8 days of order confirmation, depending on the volume of orders received.If there is any delay in receiving your order, please contact us and we will help you confirm the status of your order.</p>'
      }, {
        title: 'WHAT PAYMENT POSSIBILITIES ARE HERE?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr">You can pay by card online. The transaction is 100% secure, and we don&apos;t save your card info.</p>'
      }, {
        title: 'WHAT HAPPENS IF MY DELIVERY IS DAMAGED OR LOST?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr">We take these issues very seriously and we will deal with them on a case-by-case basis. For more information on our exchange and refund policy, please <a target="_blank" rel="noopener noreferrer nofollow" class="font-weight-bold text--white" href="/shipping-return-policy">click here</a>.</p>'
      }]
    }
  }
};